import { openOrderConfirm } from '@/actions/app';
import quoteIconClose from '@/assets/images/icons/quote_icon_close.png';
import '@/assets/styles/components/place-order-dialog.scss';
import Dropdown from '@/components/Dropdown/Dropdown';
import { APP_LANGUAGE_SUPPORTS, ORDER_TYPE } from '@/constants/app';
import { getSafe } from '@/helpers/global';
import classnames from 'classnames';
import React from 'react';
import { connect } from 'react-redux';
import { accountActions } from '@/actions/trading';
import { stockActions } from '@/actions/trading/stock.action';
import { Icons, SERVICES_RESP } from '@/configurations';
import { dataType } from '@/constants/data-type';
import { PARAMS } from '@/constants/params';
import { Converter, formatFunctions , utilsFunction } from '@/helpers/functions';
import { PlaceOrderOption , BidAsk} from '@/configurations/components-configs/components.config';
import Tips from '@/components/Tips/Tips';
import { ACCOUNT_TYPE } from '@/constants/auth';
import { KEY_CODE } from '@/constants/keys.code';
import { appEnvironment } from '@/configurations/app-configs/app.setting.config';
import { iTradeEnv } from '@/configurations/app-configs/iTrade.env';

const riskDisclosureHrefs = window?.config?.companyOptions?.riskDisclosure
const importantNoticeHrefs = window?.config?.companyOptions?.importantNotice

class PlaceOrderDialog extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isBuy: true,
      showQueue: false,
      cashAccounts: [],
      lastSearchKeyWord: props.isOther ? '' : props.data.instrumentID || '',
      spreadTable: [],
      instrument: props.data,
      isVisible: true,
      availableQuantity: 0,
      errorText: '',
      isLoadingSubmit: false,
      instrumentNotFoundMessage: '',
      isReset: !props.isOther,
      quoteData: {},
      isLoadingQuoteData: false,
      isAllowBuy:props.data.isAllowBuy === undefined ? true : props.data.isAllowBuy,
      avaiableQuantity : '',
      biddata:"",
      askdata:""
    }
  }

  componentDidMount() {
    setTimeout(this.dataInit,0)
  }

  dataInit=()=>{
    const { data, tradingAccounts, isOther, tradeConfigSettings, tradeDateInfoList } = this.props;
    const options = this.placeOrderOptionRef?.getOptions();
    if (data && data.marketID && (data.instrumentID || data.stockCode)) {
      this.props.changeMarket(data.marketID, tradeDateInfoList, tradeConfigSettings)
      this.stockIDRef.value = data.instrumentID || data.stockCode || '';
      if (isOther && this.stockIDRef.value) {
          this.handleSearchInstrument(isOther)
      }
    } else {
      this.handleSearchInstrument(isOther)
    }
    this.setState({
      isBuy: this.props.isBuy,
      spreadTable: data.spreadTable || [],
      quoteData: getSafe(() => data.quoteData, {}),
    }, () => {
      this.placeOrderOptionRef?.handleChangePrice(data.price)
      if (!isOther && data.orderType && data.orderType.value === ORDER_TYPE.TRIGGER_ORDER.value) {
        this.placeOrderOptionRef?.handleChangePrice(data.stopPrice, true)
      }
    })
    // this.stockIDRef.focus();
    this.placeOrderOptionRef?.setPrice(formatFunctions.dataFormat(getSafe(() => data.price, getSafe(() => data.refPrice, 0)), dataType.CURRENCY))
    this.placeOrderOptionRef?.setQuantity(formatFunctions.dataFormat(getSafe(() => data.quantity, getSafe(() => data.ledgerQty, 0)), dataType.NUMBER))
    if (!isOther) {
      setTimeout(() => {
        this.placeOrderOptionRef?.setGoodTillDate(data.goodTillDate)
        this.placeOrderOptionRef?.setOrderType(data.orderType, data)
      }, 0)
    }
    const cashAccounts = tradingAccounts.reduce((list, acc) => {
      if(acc.isDefault){
        list.push({
          value: acc.value,
          label: acc.label
        })
      }
      return list
    }, [])
    this.setState({ cashAccounts })
  }

  componentDidUpdate(preProps) {
    if (this.props.currentMarket && preProps.currentMarket !== this.props.currentMarket) {
      setTimeout(() => {
        this.handleSearchInstrument()
      }, 500)
    }
  }

  stockName(instrument) {
    const { language } = this.props
    switch (language.lang) {
      case APP_LANGUAGE_SUPPORTS[0].id: {
        return instrument['instrumentChineseName'] ? instrument['instrumentChineseName'] : instrument['instrumentName']
      }
      case APP_LANGUAGE_SUPPORTS[1].id: {
        return instrument['instrumentChineseName'] ? instrument['instrumentChineseName'] : instrument['instrumentName']
      }
      default: {
        // return data['stockShortName']
        return instrument['instrumentName']
      }
    }
  }

  handleGetSpreadTable(spreadTableCode, isOther = false) {
    const { language, data } = this.props;
    const params = {
      [PARAMS.SPREAD_TABLE_CODE]: spreadTableCode,
      [PARAMS.LANGUAGE]: language.lang
    }
    this.props.getSpreadTable(params, res => {
      if (res.status === SERVICES_RESP.STATUS_OK) {
        if (res.result.errorCode === SERVICES_RESP.SUCCESS_CODE) {
          this.setState({ spreadTable: res.result.spreadTableList }, () => {
            if (isOther) {
              this.placeOrderOptionRef?.handleChangePrice(data.refPrice)
            }
          })
        }
      }
    })
  }

  handleGetQuoteData = (exchangeID, instrumentID) => {
    this.setState({ isLoadingQuoteData: true });
    this.props.getQuote({ exchangeID, instrumentID }, res => {
      const quoteData = Converter.computeQuoteData(res);
      this.setState({ quoteData, isLoadingQuoteData: false })
    })
  }

  handleSearchInstrument = (isOther = false) => {
    this.setState({ errorText: '', instrumentNotFoundMessage: '' })
    const { language, currentMarket, enableQuote } = this.props;
    const keyword = this.stockIDRef.value;
    if (keyword === null || keyword === '') {
      this.setState({ instrumentNotFoundMessage: getSafe(() => language.place_order_noInput_errorMessage) })
      return
    }
    this.marketRef.setValue([this.props.markets.filter(v => v.value === this.props.currentMarket)[0]]);
    // if (keyword && keyword !== this.state.lastSearchKeyWord) {
      const params = {
        [PARAMS.MARKET_ID]: currentMarket,
        [PARAMS.INSTRUMENT_ID]: keyword.trim(),
        [PARAMS.LANGUAGE]: language.lang
      }
      this.props.getInstrumentDetail(params, res => {
        if (res.status === SERVICES_RESP.STATUS_OK) {
          if (res.result.errorCode === SERVICES_RESP.SUCCESS_CODE) {
            this.setState({ instrument: res.result, lastSearchKeyWord: res.result.instrumentID });
            this.handleGetSpreadTable(res.result.spreadTableCode, isOther);
            this.stockIDRef.value = res.result.instrumentID;
            if(currentMarket === "USEX"){
              if (enableQuote) {
                this.setState({ isLoadingQuoteData: true })

                let requestState = 'pending'
                const temporaryData = {}
  
                const renderQuoteDataFunc = (data) => {
                  const quoteData = Converter.computeQuoteData({ last: data.last, prev: data.prev })
                  this.setState({ quoteData, isLoadingQuoteData: false })
                }
  
                stockActions.getStatisticsAction({symbols: [{ exchangeID: Converter.mappingWebSocketMarket(currentMarket), key: res.result.instrumentID }]}, statisticsRes => {
                  if (statisticsRes.rtnCode) return
                  temporaryData.last = statisticsRes.last
                  stockActions.getClosingPriceAction({symbols: [{ exchangeID: Converter.mappingWebSocketMarket(currentMarket), key: res.result.instrumentID }]}, closingPriceRes => {
                    if (closingPriceRes.rtnCode) return
                    temporaryData.prev = closingPriceRes.closingPrice
                    requestState = 'success'
                    renderQuoteDataFunc({ last: statisticsRes.last, prev: closingPriceRes.closingPrice })
                  })
                })
  
                this.timeOutRef = setTimeout(() => {
                  if (requestState === 'pending') {
                    renderQuoteDataFunc(temporaryData)
                    clearTimeout(this.timeOutRef)
                  }
                }, 5000)
              }

            } else if (currentMarket === 'SZMK') {
              if (enableQuote) {
                this.setState({ isLoadingQuoteData: true })

                const params = { symbols: [{ exchangeID: Converter.mappingWebSocketMarket(currentMarket), key: res.result.instrumentID }], sessID: this.props.mdsToken }
                this.props.getDetailPriceInfo(params, quetores => {
                  if (quetores.rtnCode) return
                  const quoteData = Converter.computeQuoteData(quetores)
                  this.setState({ quoteData, isLoadingQuoteData: false, searchLoading: false })
                })
              }
            } else{
            if (this.state.isReset) {
              this.placeOrderOptionRef?.reset();
            } else {
              this.setState({
                isReset: true
              })
            }
            if (enableQuote) {
              this.handleGetQuoteData(currentMarket, res.result.instrumentID)
            }
            }
          } else if(res.result.errorCode === SERVICES_RESP.SEARCH_ERROR_CODE){
            if(res.result.errorMessage){
              this.setState({ instrumentNotFoundMessage: res.result.errorMessage, searchLoading: false })
            }else{
              this.setState({ instrumentNotFoundMessage: language.instrument_not_found_message, searchLoading: false })
            }
          }
          else {
            this.setState({ instrumentNotFoundMessage: res.result.errorMessage, searchLoading: false })
          }
        }
      })
    // }
  }

  handleInputKeyDown = (event) => {
    if (event.key === 'Enter') {
      this.stockIDRef.blur()
    }
  }

  handleClear = () => {
    this.stockIDRef.value = '';
    this.placeOrderOptionRef?.reset();
    this.setState({
      instrumentNotFoundMessage: '',
      instrument: '',
      quoteData: {},
      showQueue: false
    })
  }

  getAvailableQuantity = (qty) => {
    this.setState({ isLoadingSubmit: true })
    const { language, currentTradingAccount } = this.props;
    const { instrument } = this.state;

    const params = {
      [PARAMS.CLIENT_ID]: currentTradingAccount.clientID,
      [PARAMS.TRADING_ACCOUNT_ID]: currentTradingAccount.clientID,
      [PARAMS.TRADING_ACCOUNT_SEQ]: currentTradingAccount.tradingAccSeq,
      [PARAMS.MARKET_ID]: instrument.marketID,
      [PARAMS.INSTRUMENT_ID]: instrument.stockCode || instrument.instrumentID,
      [PARAMS.LANGUAGE]: language.lang
    }
    this.props.getAvailableQuantity(params, res => {
      if (res.status === SERVICES_RESP.STATUS_OK) {
        if (res.result.errorCode === SERVICES_RESP.SUCCESS_CODE) {
          let availableQty = res.result.avaiableQuantity ?? '0';
          availableQty = parseInt(availableQty);
          if (availableQty === 0) {
            this.setState({ errorText: language.error_message_available_qty_zero , isSell :false , isLoadingSubmit: false})
          } else if(qty > availableQty){
            this.setState({ errorText: language.error_message_more_than_available_qty , isSell :false ,isLoadingSubmit: false})
          } else {
            this.handleConfirm();
          }
        }
      }
      this.setState({ isLoadingSubmit: false , avaiableQuantity : availableQty})
    })
  }

  validateOrderRequest = (isSell) => {
    if (!this.state.instrumentNotFoundMessage) {
      const options = this.placeOrderOptionRef?.getOptions();
      const orderType = options.orderType.value;
      if(!(orderType === ORDER_TYPE.AT_AUCTION.value || orderType === ORDER_TYPE.MARKET_ORDER.value)){
        if (options.price === '0' || options.quantity === '0') {
          this.placeOrderOptionRef?.validateInput();
          return;
        }
      }
      if(orderType === ORDER_TYPE.AT_AUCTION.value){
        if (options.quantity === '0') {
          this.placeOrderOptionRef?.validateInput();
          return;
        }
      }
      this.setState({ errorText: '' })
      if (!isSell) {
        let qty = parseInt(options.quantity) 
        this.getAvailableQuantity(qty);
      } else {
        this.handleConfirm();
      }
    }
  }

  handleConfirm = () => {
    const orderData = {
      ...this.state.instrument,
      ...this.placeOrderOptionRef?.getOptions(),
      cashAccount: this.cashAccountRef.getValue()[0],
      isBuy: this.state.isBuy
    }
    this.setState({ isVisible: false })
    openOrderConfirm(orderData, (isCloseDialog = true) => {
      if (isCloseDialog) {
        this.props.onClose()
      } else {
        this.setState({ isVisible: true });
      }
    })
  }

  accountType = (val) => {
    switch (val) {
      case ACCOUNT_TYPE.CASH: {
        return this.props.language.common_cash_account
      }
      case ACCOUNT_TYPE.MARGIN: {
        return this.props.language.common_margin_account
      }
    }
  }

  copyPrice = (price) => {
    const orderType = this.placeOrderOptionRef?.getOptions().orderType.value;
    if(utilsFunction.isOrderNeedEnterPrice(orderType)){
      this.placeOrderOptionRef?.setPrice(price);
      this.placeOrderOptionRef?.handleChangePrice(price)
      this.placeOrderOptionRef?.focusPrice();
    }
  }

  handleKeyDown = (e) => {
    switch (e.keyCode) {
      case KEY_CODE.TAB_KEY: {
        this.placeOrderOptionRef?.orderTypeRef.toggleMenuOption();
        document.removeEventListener('keydown', this.handleKeyDown)
        break;
      }
      default:
        break;
    }
  }

  handleFocusSellBtn = () => {
    document.addEventListener('keydown', this.handleKeyDown)
  }

  handleBlurSellBtn = () => {
    document.removeEventListener('keydown', this.handleKeyDown)
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown)
  }

  handleChangeMarket = (market) => {
    const tradeConfig = this.props.tradeConfigSettings
    const marketID = market[0].value
    this.setState({
      isAllowBuy:true
    })
    this.props.changeMarket(marketID, this.props.tradeDateInfoList, tradeConfig)
  }

  handleAllowBuy = (orderType) =>{
    const atAuctionBuy = iTradeEnv?.pages?.trade?.atAuctionBuy ?? false;
    if(orderType[0].value === ORDER_TYPE.AT_AUCTION.value && !atAuctionBuy){
      this.setState({
        isBuy:false,
        isAllowBuy:false
      })
    }else{
      this.setState({
        isAllowBuy:true
      })
    }
  }

  handleQueueItemClick = (data, type) => {
    if (this.placeOrderOptionRef) {
      const setFunc = () => {
      const options = this.placeOrderOptionRef.getOptions();
      const price = data.price
      const quantity = options.quantity === '0' ? this.state.instrument.lotsize : options.quantity
      this.placeOrderOptionRef.setPrice(price);
      this.placeOrderOptionRef.setQuantity(quantity)
      this.placeOrderOptionRef.computeGrossAmount(price, quantity)
      }
      if (type !== undefined) {
        this.setState({ isBuy: type }, setFunc)
      } else {
        setFunc()
      }
      
    }
  }

  setBidAskData=(biddata,askdata)=>{
    this.setState({
      biddata:biddata,
      askdata:askdata
    })
  }

  render() {
    const {
      isBuy,
      showQueue,
      cashAccounts,
      spreadTable,
      instrument,
      isVisible,
      errorText,
      isLoadingSubmit,
      instrumentNotFoundMessage,
      quoteData,
      isLoadingQuoteData,
      isAllowBuy,
      avaiableQuantity,
      biddata,
      askdata
    } = this.state
    const { language, markets, tradingAccount, enableQuote, currentMarket } = this.props;
    return (
      <div style={{ display: isVisible ? 'block' : 'none' }}>
        <header className={classnames('c-dialog-title')}>
          <b>{getSafe(() => language.place_order_dialog_title)}</b>
          <img className={classnames('c-close-icon')} src={quoteIconClose} alt="quote-Icon-Close"
            onClick={() => this.props.onClose()} />
        </header>
        <section className={classnames('c-dialog-content')}>
          <div className={classnames('c-item')}>
            <div className={classnames('c-item-left')}>
              {getSafe(() => this.accountType(tradingAccount.accountType), '-')}
            </div>
            <div className={classnames('c-item-right')}>
              <Dropdown
                style={{ height: '30px', width: '100%', textAlign: 'left' }}
                selectedOptions={[cashAccounts[0]]}
                options={cashAccounts}
                innerRef={e => this.cashAccountRef = e}
              />
            </div>
          </div>
          <div className={classnames('c-item')}>
            <div className={classnames('c-item-left')}>
              <Dropdown
                className="c-item"
                style={{ height: '30px', width: '100%', textAlign: 'left' }}
                innerRef={e => this.marketRef = e}
                selectedOptions={[markets.filter(v => v.value === currentMarket)[0]]}
                options={markets}
                onChange={this.handleChangeMarket}
              />
            </div>
            <div className={classnames('c-item-right')}>
              <input type="text"
                id="c-text"
                ref={e => this.stockIDRef = e}
                onKeyDown={this.handleInputKeyDown}
                onBlur={() => this.handleSearchInstrument()} />
              <span className="clear-btn" onClick={this.handleClear}>{language.common_clear}</span>
            </div>
          </div>
          <div className={classnames('c-item')}>
            <div className={classnames('c-item-left')} style={{ flex: 1 }}>
              {instrumentNotFoundMessage
                ? <section>
                  <Tips isNoBgColor>
                    {instrumentNotFoundMessage}
                  </Tips>
                </section>
                : <div className={classnames('c-stock-name')}>
                  <b>{instrument.marketID && instrument.instrumentID ? `${instrument.marketID}.${instrument.instrumentID}` : ''}</b>
                  <b>{this.stockName(instrument)}</b>
                </div>
              }
              {!instrumentNotFoundMessage && enableQuote &&
                (isLoadingQuoteData
                  ? <Icons.Loading />
                  : <div className={classnames('c-stock-price', quoteData.classStyle)}>
                      <span className='pointer'
                        onClick={() => this.copyPrice(quoteData.last)}>{quoteData.last}</span>
                      <span>{quoteData.changeValue}</span>
                      <span>{quoteData.changePercent}</span>
                    </div>
                )}
            </div>
            {
              Boolean(this.stockIDRef?.value) && <div className={classnames('c-item-right')}  >
                <span style={{ color: '#117AA6', cursor: 'pointer' }} onClick={() => { this.setState({ showQueue: !showQueue }) }}>
                  {getSafe(() => language.place_order_dialog_bid_ask_queue)}
                </span>
              </div>
            }
          </div>
          { iTradeEnv?.pages?.placeorder?.ctrl?.BuySellBtn ? "" : <div className={classnames('c-item')}>
            {<div className={classnames('c-item-left')} style={{ flex: 1, marginRight: '8px' }}>
              <button className={classnames(isBuy ? 'c-item-buy' : '')}
                onClick={() => this.setState({ isBuy: true })}
                disabled={!isAllowBuy}
                style={isAllowBuy?{}:{cursor:'not-allowed'}}>
                <div>{getSafe(() => language.common_buy)}</div>
              </button>
            </div>}
            <div className={classnames('c-item-right')}>
              <button
                className={classnames(isBuy ? '' : 'c-item-sell')}
                onClick={() => this.setState({ isBuy: false })}
                onFocus={this.handleFocusSellBtn}
                onBlur={this.handleBlurSellBtn}>
                <div>{getSafe(() => language.common_sell)}</div>
              </button>
            </div>
          </div>}

          {
            showQueue ?
              <div style={{ marginBottom: '16px' }}>
                <BidAsk handleQueueItemClick={this.handleQueueItemClick} setBidAskData = {this.setBidAskData}/>
              </div>
              : ''
          }

          <PlaceOrderOption
            innerRef={e => this.placeOrderOptionRef = e}
            spreadTable={spreadTable}
            lotSize={instrument.lotsize}
            openGTDByTab
            showGrossAmount
            showGrossAmountBorder
            currencyID={instrument.currencyID}
            handleAllowBuy={this.handleAllowBuy.bind(this)}
            quoteData={quoteData}
            avaiableQuantity = {avaiableQuantity}
            biddata={biddata}
            askdata={askdata}
          />
          {
            errorText &&
            <section>
              <Tips isNoBgColor>
                {errorText}
              </Tips>
            </section>
          }
          { iTradeEnv?.pages?.placeorder?.ctrl?.BuySellBtn ?
          <React.Fragment>
              <div className="read-content-ttl">
                <span>{language.common_please_read} </span>
                <a target='_blank' href={riskDisclosureHrefs?.[language.lang] || '#'}>{language.common_the_risk_disclosure}</a> 
                <span> {language.common_and} </span>
                <a target='_blank' href={importantNoticeHrefs?.[language.lang] || '#'}>{language.common_important_statement}</a>
              </div>
              <section className='buy-sell-action-ttl' style={{marginTop:'autp'}}>
                {<button className='buy-btn-ttl'
                  onClick={() => this.validateOrderRequest(true)}
                  disabled={!isAllowBuy}
                  style={isAllowBuy?{}:{cursor:'not-allowed',background:'#424F5F'}}>{language.common_buy}</button>}
                <button className='sell-btn-ttl'
                  onClick={() => this.validateOrderRequest(false)}>{isLoadingSubmit ? <Icons.Loading /> : language.common_sell}</button>
              </section>
              </React.Fragment> 
          : <button
            type="button"
            onClick={()=>this.validateOrderRequest(this.state.isBuy)}
            style={{ backgroundColor: isBuy ? '#CC3D3D' : '#32BD73', marginTop: errorText ? 0 : 25 }}
            className={classnames('c-item-submit', isLoadingSubmit && 'disabled')}
          >
            {isLoadingSubmit ? <Icons.Loading /> : getSafe(() => language.common_submit)}
          </button>}
        </section>
      </div>
    )
  }
}

PlaceOrderDialog.defaultProps = {
  isOther: false,
  enableQuote: appEnvironment.custom_ctr_configs.marketCtr.enableQuote,
  enabledSearchInstrument: true
}

export default connect(
  state => ({
    language: state.app.language,
    tradingAccounts: state.trade.tradingAccounts,
    markets: state.trade.markets,
    currentTradingAccount: state.trade.currentTradingAccount,
    currentMarket: state.trade.currentMarket,
    tradingAccount: state.auth.tradingAccount,
    tradeConfigSettings: state.trade.tradeConfigSettings,
    orderTypes: state.trade.orderTypes,
    tradeDateInfoList: state.trade.tradeDateInfoList
  }),
  dispatch => ({
    getInstrumentDetail: (p, res) => dispatch(stockActions.getInstrumentDetailAction(p, res)),
    getSpreadTable: (p, res) => dispatch(stockActions.getSpreadTableAction(p, res)),
    getAvailableQuantity: (p, res) => dispatch(accountActions.getAvailableQuantityAction(p, res)),
    getQuote: (p, res) => stockActions.enquireInstrumentInfoAction(p, res),
    changeMarket: (p, p2, res) => dispatch(stockActions.changeMarketAction(p, p2, res))
  })
)(PlaceOrderDialog)
